/**
 * 充值套餐
 */
import Layout from '../../pages/layout/Frame';

const rechargePackage = {
    path: "/rechargePackage",
    component: Layout,
    meta: {title: '充值套餐'},
    name: "rechargePackage_list",
    children: [
        {
            path: "/rechargePackage/index",
            component: () => import('../../pages/rechargePackage/index'),
            meta: {title: '充值套餐',},
            name: 'rechargePackage_list',
        },
    ]
};

export default rechargePackage
